














import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component
export default class UrlWrapper extends Vue {
  @Prop() url!: string
  @Prop({ default: 10 }) scrollSpeed: number
  id: string = dayjs(new Date).valueOf().toString()

  redirect() {
    if (!this.isTextSelected())
      window.open(this.url)
  }

  mounted() {
    if (document.querySelector(`#scrollable${this.id}`)) {
      document.querySelector(`#scrollable${this.id}`).addEventListener('wheel', this.preventScrollY, { passive: false })
      document.querySelector(`#scrollable${this.id}`).addEventListener('mouseup', this.mouseUp, { passive: false })
    }
  }

  mouseMove() {
    if (this.isTextSelected())
      document.getElementById(`input${this.id}`).style.cursor = 'text'
    else document.getElementById(`input${this.id}`).style.cursor = 'pointer'
  }

  mouseUp(e) {
    if (!this.isTextSelected())
      window.open(this.url)
  }

  preventScrollY(e) {
    e.preventDefault();
    (e.wheelDelta > 0)
      ? document.querySelector(`#input${this.id}`).scrollLeft = document.querySelector(`#input${this.id}`)
        .scrollLeft - this.scrollSpeed
      : document.querySelector(`#input${this.id}`).scrollLeft = document.querySelector(`#input${this.id}`)
        .scrollLeft + this.scrollSpeed
    return false
  }

  isTextSelected() {
    return document.getSelection().toString() !== ''
  }

  barStyle = {
    right: '0px',
    borderRadius: '0px',
    backgroundColor: '#027be3',
    width: '0px',
    opacity: 0.0
  }

  thumbStyle = {
    right: '0px',
    borderRadius: '0px',
    backgroundColor: '#027be3',
    width: '0px',
    opacity: 0
  }

}
